export default "__VITE_ASSET__30988ed8__"